import { useContainer } from '@hub-la/fe-container'
import { HttpClient } from '@hub-la/fe-core-http-client'
import { useQuery } from '@tanstack/react-query'
import { GetCanceledSubscriptionsInput } from '../../domain/dtos/get-canceled-subscriptions-input'
import { Indicator } from '../../domain/enums/indicator'
import { QueryKey } from '../../domain/enums/query-keys'
import { Status } from '../../domain/enums/status'
import { GetCanceledSubscriptions } from '../../usecases/get-canceled-subscriptions'

export const useGetCanceledSubscriptions = (input: GetCanceledSubscriptionsInput, isLoading: boolean) => {
  const container = useContainer()

  const offerIds = input.offers.filter(({ id }) => id !== 'all').map(({ id }) => id)
  const enabled = !isLoading && offerIds.length > 0
  const initialData = {
    current: 0,
    previous: 0,
    percentage: '',
    status: Status.neutral,
    indicator: Indicator.down,
  }

  return useQuery(
    [
      QueryKey.getCanceledSubscriptions,
      JSON.stringify({
        period: input.period,
        startDate: input.startDate,
        endDate: input.endDate,
        offerIds: input.offerIds,
      }),
    ],
    ({ signal }) => {
      if (!enabled) {
        return Promise.resolve(initialData)
      }
      return new GetCanceledSubscriptions(container.get(HttpClient)).execute(input, signal)
    },
    {
      retry: 3,
      retryOnMount: false,
      refetchOnWindowFocus: false,
      initialData,
      enabled,
    },
  )
}
